import { openDB } from "idb";

const DB_NAME = "MoxWalletDB";
const STORE_NAME = "encryptedWallets";

async function getDB() {
  return await openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    }
  });
}

export async function saveEncryptedWallet(username: string, data: string) {
  const db = await getDB();
  await db.put(STORE_NAME, data, username);
}

export async function loadEncryptedWallet(username: string): Promise<string | null> {
  const db = await getDB();
  return (await db.get(STORE_NAME, username)) || null;
}

export async function deleteEncryptedWallet(username: string) {
  const db = await getDB();
  await db.delete(STORE_NAME, username);
}

